<template>
  <div class="mask">
    <div class="bd-radio-8 fb bg-FFFFFF loading-box">
      <img
        class="mr-24 ml-32 rotate"
        src="../assets/images/icon_update.png"
        alt=""
      />
      <p class="content font-30 c-171A1D-56 item-order-1">{{ content }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: '加载中...'
    },
    iconname: {
      type: String,
      default: ''
    },
    showLayer: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.mask {
  background-color: rgba(0, 0, 0, 0.28);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.loading-box {
  width: 70%;
  padding: 20px 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #ffffff;
}
.loading-box img {
  display: inline-block;
  width: 24px;
  height: 24px;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

.rotate {
  animation: rotate 1s 0s ease-in-out infinite;
  -webkit-animation: rotate 1s 0s ease-in-out infinite;
}
</style>
